




























import Vue from "vue";
import AppLayout from "@/components/app-layout.vue";
import store from "@/store";
import { mapGetters } from "vuex";
import { Activite } from "@/models/Activite";
import AppAdo from "@/components/app-ado.vue";
import activiteCategorie from "@/features/activites/components/activite-categorie.vue";

export default Vue.extend({
  beforeRouteEnter(from, to, next) {
    store.dispatch("activites/fetchActivites").then(function () {
      store.dispatch("activites/fetchTypesActivites").then(function () {
        store.dispatch("activites/filtreActivites").then(function () {
          next();
        });
      });
    });
  },
  components: {
    AppLayout,
    AppAdo,
    activiteCategorie,
  },
  computed: {
    ...mapGetters("activites", [
      "getActivites",
      "getTypesActivites",
      "getFiltredActivites",
    ]),
    ...mapGetters("etablissements", [
      "getCurrentEtablissement"
    ])
  },
  methods: {
    filterActiviteByCategorie(categorieKey: any) {
      let filtredList: Activite[] = [];
      this.getActivites.forEach((activite: Activite) => {
        if (activite.getCategorie_nom() == categorieKey) {
          filtredList.push(activite);
        }
      });
      return filtredList;
    },
    selectActivite(activite: Activite) {
      console.log(activite);
      this.$store.dispatch("activites/selectActivite", activite);
    },
    showInfos(event : any){
      console.log(event)
      this.$store.dispatch("activites/setCurrentDate",event); 
    }
  },
});
